import "./svg/precent-2.svg"

export default {
    name: "precent-2",
    viewBox: "24 24",
}
